import React from "react";
import { NavLink } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { COLORS } from "../definitions/colors";

const MenuOption = ({image, alt, name, dest}) => {

    const fadeInUp = keyframes`
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    `;

    const Holder = styled.div`
        aspect-ratio : 1 / 1;
        width: calc(50% - 1rem);
        opacity: 0;
        animation: ${fadeInUp} 0.6s ease-out forwards;

        @media (max-width: 758px) {
            width: 80%;
        }
    ` 

    const Background = styled.div`
        position: relative;
        display: flex;
        justify-content: center;
        aspect-ratio : 1 / 1;
        background: linear-gradient(135deg, #1a0d10 0%, ${COLORS.accent} 40%, #3d1f26 100%);
        margin: 0.5rem;
        padding: 0;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        border: 3px solid ${COLORS.accent};

        &:hover {
            transform: translateY(-5px) scale(1.02);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
        }
    `

    const Image = styled.img`
        aspect-ratio: 1/1;
        width: 100%;
        object-fit: cover;
    `

    const Button = styled(NavLink)`
        position: absolute;
        background: linear-gradient(135deg, rgba(26, 13, 16, 0.92) 0%, rgba(40, 19, 24, 0.95) 100%);
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        opacity: 0%;
        width: 100%;
        height: 100%;
        top: 0;
        transition: opacity 0.3s ease;
        font-size: 2.6em;
        color: ${COLORS.whiteText};
        text-decoration: none;
        backdrop-filter: blur(1.5px);

        &:hover {
            opacity: 100%;
        }

        @media (max-width: 768px){
            opacity: 100%;
            background: linear-gradient(to top, rgba(26, 13, 16, 0.95) 0%, rgba(26, 13, 16, 0.6) 40%, transparent 70%);
            backdrop-filter: blur(0.5px);
        }
    `

    const HeaderText = styled.h1`
        font-size: 1.3em;
        text-align: center;
        padding: 0px;
        margin: 0px;
        text-shadow: 0 3px 10px rgba(0, 0, 0, 0.8), 0 0 20px rgba(0, 0, 0, 0.6);
        font-weight: bold;

        @media (max-width: 768px){
            font-size: 1.3em;
            text-shadow: 0 3px 10px rgba(0, 0, 0, 0.9), 0 0 25px rgba(0, 0, 0, 0.7);
        }
    `

    const ShowOffer = styled.p`
        font-size: 0.5em;
        background: ${COLORS.whiteText};
        color: ${COLORS.accent};
        padding: 0.6rem 1.2rem;
        border-radius: 25px;
        font-weight: bold;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        margin-top: 1rem;

        @media (max-width: 768px){
            padding: 0.5rem 1rem;
        }
    `

    return (
        <Holder>
            <Background>
                <Image src={image} alt={alt}></Image>
                <Button to={dest}>
                    <HeaderText>{name}</HeaderText>
                    <ShowOffer>Zobacz ofertę</ShowOffer>
                </Button>
            </Background>
        </Holder>
    )
}

export default MenuOption
